import { render, staticRenderFns } from "./doorRoll.vue?vue&type=template&id=66f98f2c&scoped=true&"
import script from "./doorRoll.vue?vue&type=script&lang=js&"
export * from "./doorRoll.vue?vue&type=script&lang=js&"
import style0 from "./doorRoll.vue?vue&type=style&index=0&id=66f98f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f98f2c",
  null
  
)

export default component.exports